import { Dialog, DialogContent } from "../components/ui/dialog";
import { useAuth } from "wasp/client/auth";
import ExcelReimportView from "../views/ExcelReimportView";
import { AlertTriangle } from "lucide-react";
import { useTranslation } from "../i18n/hooks";

type ExcelReimportDialogProps = {
  open: boolean;
  onOpenChange: (arg: boolean) => void;
};

const ExcelReimportDialog = ({open, onOpenChange}: ExcelReimportDialogProps) => {
  const { data: user } = useAuth();
  const { t } = useTranslation();
  
  if (!user) return null;
  return (
    <Dialog
      open={open}
      onOpenChange={onOpenChange}
    >
      <DialogContent className="p-6">
        <h1 className="text-lg font-semibold">{t("excelReimportDialog.import_excel")}</h1>
        <h2 className="text-red-600 font-medium bg-slate-50 p-3 rounded-lg flex items-center gap-2">
          <AlertTriangle className="h-5 w-5" />
          {t("excelReimportDialog.replace_warning")}
        </h2>
        <ExcelReimportView />
      </DialogContent>
    </Dialog>
  );
};

export default ExcelReimportDialog;
